
<template>
  <AddEncaissement />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumbs from "@/layout/BreadCrumbs.vue";
import AddEncaissement from "@/components/GesCom/Operations/AddEncaissement.vue";

export default defineComponent({
  name: "AddEncaissementPage",
  components: {
    BreadCrumbs,
    AddEncaissement,
  },
});
</script>

